import fileRouterPaths from './fileRouterPaths';

export default fileRouterPaths;
